import React, { useEffect } from 'react';
import clsx from 'clsx';
import Head from 'next/head';
import { DEFooter } from 'components/Footers/DEFooter/DEFooter';
import { LoggedOutNavigation } from 'components/Navigation/LoggedOutNavigation';
import { Navigation } from 'components/Navigation/Navigation';
import { useLocale } from 'hooks/useLocale';
import { getCookie } from 'utils/cookieHelper';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { trackPageVisited } from 'utils/tracking/trackPageVisited';
import styles from './BaseLayout.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  pageTitle: string;
  showDEFooter?: boolean;
};

export const BaseLayout = ({
  children,
  className,
  pageTitle,
  showDEFooter = false,
}: Props) => {
  const isLoggedIn = getCookie('isLoggedIn') === 'True';
  const { locale, isDE } = useLocale();

  useEffect(() => {
    trackPageVisited(pageTitle, locale);
  }, [locale, pageTitle]);

  showDEFooter = showDEFooter && isDE;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="title" />
      </Head>
      <div>
        {isLoggedIn ? <Navigation /> : <LoggedOutNavigation />}
        <main
          className={clsx(
            styles.mainContent,
            { [styles.hasFooter]: showDEFooter },
            { [styles.isStaging]: getEnvironment() === 'staging' },
            className,
          )}
        >
          {children}
        </main>
        {showDEFooter && <DEFooter />}
      </div>
    </>
  );
};
